module.exports = __webpack_public_path__ + "img/undraw_online_groceries_a02y.d970c46d.svg";